import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/student/homepage/lock.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-04bdd444")

_pushScopeId("data-v-04bdd444")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "rotation" }
const _hoisted_3 = {
  key: 0,
  class: "lock"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  width: "25",
  height: "25",
  src: _imports_0
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "actions flex justify-end"
}
const _hoisted_6 = { class: "info flex ml12 align-items-center" }
const _hoisted_7 = { class: "line mr12" }
const _hoisted_8 = { class: "txt" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "可以在上面区域使用鼠标滚轮进行横向滚动", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "mouse mt32" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cardListVue = _resolveComponent("cardListVue")
  const _component_a_popover = _resolveComponent("a-popover")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_cardListVue, {
        "data-source": _ctx.dataList,
        onHandleClick: _ctx.handleClick,
        id: "cardListVue"
      }, {
        foot: _withId(({ record }) => [
          (record.caseData?.isUnLock)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(record.caseData?.statusList, (v, i) => {
                  return (_openBlock(), _createBlock("div", _hoisted_6, [
                    _withDirectives(_createVNode("div", _hoisted_7, null, 512), [
                      [_vShow, i !== 0]
                    ]),
                    _createVNode("div", _hoisted_8, _toDisplayString(v), 1)
                  ]))
                }), 256))
              ]))
        ]),
        _: 1
      }, 8, ["data-source", "onHandleClick"])
    ]),
    _createVNode(_component_a_popover, null, {
      content: _withId(() => [
        _hoisted_9
      ]),
      default: _withId(() => [
        _hoisted_10
      ]),
      _: 1
    })
  ]))
})